import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {ButtonGroup} from 'shells/button-group/button-group';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconSetupIcon} from 'shells/icon/svg/sidebar-icon-setup';
import {Link} from 'shells/link/link';

import {EmailHealthRoot} from './email-health/email-health-root';

export function EmailHeaderButtons() {
    return (
        <ButtonGroup>
            <EmailHealthRoot />
            <Link
                variant='button-secondary'
                // @ts-expect-error
                as={RouterLink}
                to='/my-account/email-sending'
                size='big'
                icon={SidebarIconSetupIcon}
            >
                Email settings
            </Link>
        </ButtonGroup>
    );
}
